// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"28ad6d8f","136":"f1b66d42","140":"920686bb","574":"31d6cfe0","955":"bf4858d7"}[chunkId] + ".chunk.css";
};